interface StateType {
    kvBackground: string;
    qiuBackground: string;
    buyhistoryBackground: string;
    openhistoryBackground: string;
    leftbtnBackground: string;
    rightbtnBackground: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        kvBackground: '',
        qiuBackground: '',
        buyhistoryBackground: '',
        openhistoryBackground: '',
        leftbtnBackground: '',
        rightbtnBackground: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
